<!-- table组件  -->
<template>
  <el-table
    :data="data"
    ref="multipleTable"
    style="width: 100%;"
    :height="tableHeight"
    @selection-change="handleSelectionChange"
    @sort-change="sortChange"
    :key="showSelcet"
  >
    <el-table-column type="selection" align="center" v-if="showOperation && showSelcet" width="45"></el-table-column>
    <!-- table 第一格 序号  -->
    <el-table-column type="index" :label="$t('SerialNo')" width="80" align="center" :show-overflow-tooltip="true">
      <template slot-scope="scope">
        <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }} </span>
      </template>
    </el-table-column>
    <!-- table  每一列的循环  -->
    <el-table-column
      v-for="(item, index) in columns"
      :key="index"
      :align="item.align ? item.align : 'left'"
      :sortable="item.sort"
      :prop="item.attrName"
      :label="item.label"
      :width="item.width"
      :sort-orders="['ascending', 'descending']"
      :show-overflow-tooltip="true"
    >
      <template slot-scope="scope">
        <!-- 可点击 -->
        <span class="click-text" v-if="item.allowHande" @click="handleToEven(item.allowHande, scope.row)">
          {{ scope.row[item.attrName] }}</span
        >
        <!-- item.rowBranch 配置 rowBranch 循环显示内容 -->
        <span class="normal-text" v-else-if="item.rowBranch">
          <p v-for="(item, index) in scope.row.records"
          :key="index">{{ item }}</p>
          </span>
        <span class="normal-text" v-else>{{ $t(scope.row[item.attrName] )}}</span>
      </template>
    </el-table-column>
    <!-- 循环操作数据显示 -->
    <el-table-column align="center" v-if="showOperation && type" :label="$t('operationh')" :width="operationWidth">
      <template slot-scope="scope">
        <span
          v-for="(item, index) in operation"
          :key="index"
          :class="item.class"
          v-has="'sys:new:setting:log:data:delete'"
          @click="operateType(item.type, scope.row, scope.$index)"
          >{{ item.operateName }}
          <img v-if="item.icon" class="oprat-icon" :src="item.icon" alt="" />
        </span>
      </template>
    </el-table-column>
    <!-- 循环操作数据显示 -->
    <el-table-column v-if="operation.length > 0 && !type" align="center" :label="$t('operationh')" :width="operationWidth">
      <template slot-scope="scope">
        <span
          v-for="(item, index) in operation"
          :key="index"
          :class="item.class"
          @click="operateType(item.type, scope.row, scope.$index)"
          >{{ item.operateName }}
          <img v-if="item.icon" class="oprat-icon" :src="item.icon" alt="" />
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { searchMenuCode, warning } from '@/util/common'
import {
  batterysDelete,
  modulesDelete,
  mediaUploadInfoDelete,
  geoFencesDelete,
  mobileDatasDelete,
  callsDelete,
  emergencyHelpDelete,
  operationsDelete,
} from '@/api/log/logDelet'
import { voiceDetectDelete, faceDetectDelete } from '@/api/log'
import { batchDeleteSwitch } from '@/api/log/logSwitch'
export default {
  name: 'commontable',
  props: {
    /**
     * 表头以及传参
     * { attrName: 'userName', label: '用户名' },
     */
    columns: {
      type: Array,
      default: () => [],
    },
    // table 数据
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * 操作数组
     * {
          operateName: '', 操作名
          icon: require('@/icon/ic_delete.png'), 操作代表图片
          type: 'delect', 操作类型
          IsHad: '', 判断是否有权限
        },
     */
    operation: {
      type: Array,
      default: () => [],
    },
    // 操作栏的宽度
    operationWidth: {
      type: Number,
      default: () => 0,
    },
    numWidth: {
      type: Number,
      default: () => 0,
    },
    // 当前页
    currentPage: {
      type: Number,
      default: () => 0,
    },
    // 当前条/页
    pageSize: {
      type: Number,
      default: () => 0,
    },
    // 高度
    tableHeight: {
      type: Number,
      default: () => 600,
    },
    type: {
      type: String,
      default: '',
    },
    // 哪一列是否允许操作
    allowHandel: {
      type: String,
    },
    showSelcet: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showOperation: searchMenuCode('sys:new:setting:log:data:delete'),
      multipleSelection: [],
    }
  },
  methods: {
    sortChange({ column, prop, order }) {
      this.$emit('sortChange', { column, prop, order })
    },
    handleToEven(valType, data) {
      if (valType === 'dataCenter') {
        this.$router.push({
          path: '/newIndex/mediaData',
          query: {
            id: data.userId,
            name: data.userName,
          },
        })
        this.$store.commit('currentIndex', 'dataCenter')
      }
    },
    // 选择框选择的内容
    handleSelectionChange(val) {
      console.log('table选择框', val)
      this.multipleSelection = val
    },
    handleSelectionEmpty() {
      this.$refs.multipleTable.clearSelection()
    },
    // 循环所选列表 过滤需要的内容
    handleDeletList() {
      if (this.multipleSelection.length <= 0) {
        warning(this.$t('selectrecordDelete'))
        return
      }
      if (this.type === 'emergencyHelp' || this.type === 'operation') {
        let helpData = []
        for (let item of this.multipleSelection) {
          helpData.push(item.id)
        }
        this.handleDelets(helpData)
      } else if (this.type === 'Voiceprint') {
        let voiceData = []
        for (let item of this.multipleSelection) {
          voiceData.push(item.id)
        }
        this.handleDelets(voiceData)
      } else if (this.type === 'Faceprint') {
        let faceData = []
        for (let item of this.multipleSelection) {
          faceData.push(item.id)
        }
        this.handleDelets(faceData)
      } else if (this.type === 'ModeSwitching') {
        let modeData = []
        for (let item of this.multipleSelection) {
          modeData.push(item.id)
        }
        this.handleDelets(modeData)
      } else {
        let batterydata = []
        for (let item of this.multipleSelection) {
          batterydata.push({
            userId: item.userId,
            sid: item.sid,
            logTimestamp: item.logTimestamp,
          })
        }
        this.handleDelets(batterydata)
      }
    },
    // 批量删除
    handleDelets(param) {
      this.$confirm(this.$t('deleteCheckedRecord'), '', {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        switch (this.type) {
          case 'battery':
            batterysDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'call':
            callsDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'geoFence':
            geoFencesDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'mediaUpload':
            mediaUploadInfoDelete(param).then(res => {
              if (res.state === 0) {
                this.delectTip()
                this.$emit('getList')
              }
            })
            break
          case 'mobileData':
            mobileDatasDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'module':
            modulesDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'operation':
            operationsDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'Voiceprint':
            voiceDetectDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'Faceprint':
            faceDetectDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'emergencyHelp':
            emergencyHelpDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'ModeSwitching':
            batchDeleteSwitch(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
          default:
        }
      })
    },
    delectTip() {
      this.handleSelectionEmpty()
      this.$message({
        type: 'success',
        message: this.$t('batchDeletionSucceeded'),
      })
    },
    // 修改table header的背景色
    tableHeaderColor() {
      return 'background-color: #F4F4F4;'
    },
    operateType(type, value, index) {
      this.$emit('operate', { type: type, value: value, index: index })
    },
    checkType(type, value) {
      let label = ''
      switch (type) {
        case 'status': //状态：是否启用
          if (value === 1) {
            label = '启用'
          } else {
            label = '禁用'
          }
          break
        case 'bugstatus': //BUG 的状态
          if (value === 1) {
            label = '未关闭'
          } else {
            label = '关闭'
          }
          break
        default:
          label = value
      }
      return label
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.editClick
  margin-right 10px
  // color #00DEFF
  cursor pointer
  word-wrap:break-word;
.click-text
  cursor pointer
  color #09f
</style>
